import Form from "react-bootstrap/Form";
import { Calendar } from "primereact/calendar";
import "primereact/resources/themes/bootstrap4-light-blue/theme.css";
import { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import LoadingPage from "./LoadingPage";
import { MessageError } from "./MessageError";
import { listTypeUsers } from "../global/GlobalVariables";
import {
  getSpecificUser,
  getPlans,
  deepUpdateUserData,
  deleteUser,
} from "../api/admin/adminServices";
import { isValidEmail } from "../global/GlobalFunctions";
import { Toaster, toast } from "sonner";
import ModalAlertLoading from "./ModalAlertLoading";
import ModalConfirm from "./ModalConfirm";
import { invertPlanName } from "./functions/Dashboard";

export function EditUser(props) {
  const { statusMode } = props;
  const [valueCalendar, setValueCalendar] = useState(new Date());
  const [pageSession, setPageSession] = useState("loading");
  const [dataUserToShow, setDataUserToShow] = useState({});
  const [dateRegister, setDataRegister] = useState("00/00/0000");
  const [namePlan, setNamePlan] = useState("nothing");
  const [nameUserType, setNameUserType] = useState("nothing");
  const oldUserDataStorage = useRef({});
  const [canUpdateUser, setCanUpdateUser] = useState(false);
  const [listPlans, setListPlans] = useState([]);
  const infoPlans = useRef({});
  const params = useParams();
  const [email, setEmail] = useState("");
  const [messageModal, setMessageModal] = useState("");
  const [showModalMessage, setShowModalMessage] = useState(false);
  const [iconToShow, setIconToShow] = useState("");
  const listNamePlansToShow = useRef({});
  const [showModalConfirm, setShowModalConfirm] = useState(false);
  const functionStorage = useRef(function(){});


  const changeUserType = (event) => {
    setNameUserType(event.target.value);
  };

  const changeUserPlan = (event) => {
    let daysPlan = infoPlans.current[event.target.value]["days"];
    let nowDateTime = new Date();
    nowDateTime.setDate(nowDateTime.getDate() + daysPlan);
    setNamePlan(event.target.value);
    setValueCalendar(nowDateTime);
  };

  const ChangeValueCalendar = (event) => {
    setValueCalendar(new Date(event.target.value));
  };

  function updateUser(userReply) {
    if (userReply === true) {
      let list_data_to_send = {
        id: oldUserDataStorage.current.id,
        date_expiration: valueCalendar,
        plan_name:
          listNamePlansToShow.current[namePlan] !== undefined
            ? listNamePlansToShow.current[namePlan][0]
            : "gratuito",
        user_type:
          nameUserType === "" || nameUserType === undefined
            ? "user"
            : nameUserType,
        email: email.toLocaleLowerCase(),
      };
      setIconToShow("");
      setMessageModal("Aguarde enquanto atualizamos os dados do usuário.");
      setShowModalMessage(true);

      deepUpdateUserData(list_data_to_send).then((data) => {
        if (data["statusHttp"] !== 200) {
          setMessageModal(data["message"]);
          setIconToShow("error");
          setCanUpdateUser(false);
        } else {
          setMessageModal("Dados do usuário atualizados com sucesso!");
          loadDataOnPage(true);
        }
      });
    }
  }

  function RemoveUser(userReply) {
    if (userReply === true) {
      setIconToShow("");
      let list_data_to_send = {
        id: oldUserDataStorage.current.id,
      };
      setMessageModal("Aguarde um momento, estamos removendo o usuário.");
      setShowModalMessage(true);
      deleteUser(list_data_to_send).then((data) => {
        if (data["statusHttp"] !== 200) {
          setMessageModal(data["message"]);
          setIconToShow("error");
          setCanUpdateUser(false);
        } else {
          setIconToShow("success");
          setMessageModal("Remoção concluída: usuário removido com sucesso!");
        }
      });
    }
  }

  const handleChangeEmailAddress = (event) => {
    setEmail(event.target.value);
  };

  function loadDataOnPage(canUpdateMessageModal = false) {
    if (canUpdateMessageModal === true) {
      setMessageModal("Aguarde enquanto carregamos os dados do usuário.");
    }
    if ("id" in params) {
      let userId = Number(params.id);
      let dataToSend = { id: userId };
      getSpecificUser(dataToSend, setPageSession).then((data) => {
        if (data["statusHttp"] === 404) {
          let messageError =
            "O usuário solicitado não foi encontrado em nossa base de dados.";
          if ("message" in data && data["message"] === messageError) {
            setPageSession("error");
          }

          return;
        }
        const plansNamesInverted = invertPlanName(listNamePlansToShow);
        let dataUser = data["value"];
        dataUser.tipo_de_plano = plansNamesInverted[dataUser.tipo_de_plano];

        let userDateRegister = (dataUser.data_cadastro + "T00:00:00");
        const userDateRegisterFormatDate = new Date(userDateRegister);

        const day = String(userDateRegisterFormatDate.getDate()).padStart(
          2,
          "0"
        );
        const month = String(
          userDateRegisterFormatDate.getMonth() + 1
        ).padStart(2, "0");
        const year = userDateRegisterFormatDate.getFullYear();

        const brazilianFormat = `${day}/${month}/${year}`;

        setDataRegister(brazilianFormat);
        setValueCalendar(
          dataUser.data_expiracao
            ? new Date((dataUser.data_expiracao + "T00:00:00"))
            : new Date( (dataUser.data_cadastro + "T00:00:00") )
        );

        oldUserDataStorage.current = JSON.parse(JSON.stringify(dataUser));

        oldUserDataStorage.current.data_expiracao = dataUser.data_expiracao
          ? new Date( (dataUser.data_expiracao + "T00:00:00"))
          : new Date( (dataUser.data_cadastro + "T00:00:00"));
        setNamePlan(dataUser.tipo_de_plano);
        setNameUserType(dataUser.username);
        setEmail(dataUser["email"]);
        setDataUserToShow(dataUser);
        setPageSession("found");
        setMessageModal("Dados do usuário carregado com sucesso!");
        setIconToShow("success");
      });
    } else {
      setPageSession("error");
    }
  }

  useEffect(() => {
    if ("id" in params) {
      getPlans().then((data) => {
        let plans = data["value"];
        let listPlans = [];
        let newListNamePlansToShow = {};
        let newInfoPlans = {};
        for (let i = 0; i < plans.length; i++) {
          let item = plans[i];

          if (newListNamePlansToShow[item["short_name"]] === undefined) {
            newListNamePlansToShow[item["short_name"]] = [];
            newInfoPlans[item["short_name"]] = item;
            listPlans.push(item["short_name"]);
          }
          newListNamePlansToShow[item["short_name"]].push(item["name"]);
        }

        setListPlans(listPlans);
        infoPlans.current = newInfoPlans;
        listNamePlansToShow.current = newListNamePlansToShow;

        loadDataOnPage();
      });
    } else {
      setPageSession("error");
    }
  }, []);

  useEffect(() => {
    let oldUserData = oldUserDataStorage.current;

    oldUserData["data_expiracao"] = oldUserData["data_expiracao"]
      ? new Date(oldUserData["data_expiracao"])
      : new Date(oldUserData["data_cadastro"]);

    if (oldUserData["data_expiracao"].getTime() !== valueCalendar.getTime()) {
      setCanUpdateUser(false);
    } else if (oldUserData["tipo_de_plano"] !== namePlan) {
      setCanUpdateUser(false);
    } else if (oldUserData["username"] !== nameUserType) {
      setCanUpdateUser(false);
    } else if (oldUserData["email"] !== email) {
      setCanUpdateUser(false);
    } else {
      setCanUpdateUser(true);
    }
  }, [namePlan, valueCalendar, nameUserType, email]);

  function startUpdateUser() {
    let emailOk = isValidEmail(email);
    if (emailOk === false) {
      toast.error(
        "E-mail inválido. Por favor, insira um endereço de e-mail válido."
      );
    } else {
      functionStorage.current = updateUser;
      setShowModalConfirm(true);
      setMessageModal("Tem certeza de que deseja atualizar esta conta?");
    }
  }

  function startDelete() {
    functionStorage.current = RemoveUser;
    setShowModalConfirm(true);
    setMessageModal(
      "Tem certeza mesmo que deseja excluir esta conta? Essa ação não pode ser desfeita."
    );
  }

  return (
    <>
      {pageSession === "found" ? (
        <>
          <Toaster />
          <ModalAlertLoading
            messageModal={messageModal}
            show={showModalMessage}
            setShow={setShowModalMessage}
            iconToShow={iconToShow}
          />

          <ModalConfirm
                  messageModal={messageModal}
                  show={showModalConfirm}
                  setShow={setShowModalConfirm}
                  functionStorage={functionStorage}
          />
          <style>
            {`
            body{
                ${
                  statusMode
                    ? "background-color: #16171b;"
                    : "background-color: #fdfafe;"
                }
                
            }
                
            `}
          </style>
          <div className="position-relative">
            <div id="dashboard-bg-container"></div>

            <div id="dashboard-container-users">
              <div
                id="dashboard-user-information-container"
                className={`${statusMode ? "dark-mode" : "light-mode"}`}
              >
                <div
                  id="dashboard-inner-user-information-container"
                  className="w-100 "
                >
                  <h1
                    id="dashboard-title"
                    className={`${statusMode ? "text-light" : ""}`}
                  >
                    Informações do Usuário
                  </h1>

                  <div
                    id="dashboard-edit-user-info-setting"
                    className={`mt-3 ${
                      statusMode ? "dark-mode" : "light-mode"
                    }`}
                  >
                    <div className="w-100">
                      <div>
                        <span className="text-secondary fw-semibold dashboard-form-edit-user-title">
                          Nome
                        </span>
                        <br />
                        <p
                          className={`fw-bold dashboard-form-edit-user-sub-title text-break ${
                            statusMode ? "text-light" : ""
                          }`}
                        >
                          {dataUserToShow["nome"]}
                        </p>
                      </div>
                      <div>
                        <span className="text-secondary fw-semibold dashboard-form-edit-user-title">
                          Email
                        </span>
                        <br />

                        <div>
                          <input
                            type="email"
                            className="form-control dashboard-form-edit-user-email-field"
                            id="exampleFormControlInput1"
                            placeholder="name@example.com"
                            value={email}
                            onChange={handleChangeEmailAddress}
                          />
                        </div>
                      </div>
                      <div>
                        <span className="text-secondary fw-semibold dashboard-form-edit-user-title">
                          Data cadastro
                        </span>
                        <br />
                        <p
                          className={`fw-bold dashboard-form-edit-user-sub-title text-break ${
                            statusMode ? "text-light" : ""
                          }`}
                        >
                          {dateRegister}
                        </p>
                      </div>
                      <div>
                        <span className="text-secondary fw-semibold dashboard-form-edit-user-title">
                          Phone
                        </span>
                        <br />
                        <p
                          className={`fw-bold dashboard-form-edit-user-sub-title text-break ${
                            statusMode ? "text-light" : ""
                          }`}
                        >
                          {dataUserToShow["phone"]}
                        </p>
                      </div>
                      <div>
                        <span className="text-secondary fw-semibold dashboard-form-edit-user-title">
                          Username
                        </span>
                        <br />

                        <Form.Select
                          className="dashboard-form-edit-user-selector"
                          aria-label="Default select example"
                          value={nameUserType}
                          onChange={changeUserType}
                        >
                          {listTypeUsers.map((item, index) => {
                            return (
                              <option key={index} value={item}>
                                {item}
                              </option>
                            );
                          })}
                        </Form.Select>
                      </div>
                    </div>
                    <div className="w-100">
                      <div>
                        <span className="text-secondary fw-semibold dashboard-form-edit-user-title">
                          Tipo de plano
                        </span>
                        <br />
                        <Form.Select
                          className="dashboard-form-edit-user-selector"
                          aria-label="Default select example"
                          value={namePlan}
                          onChange={changeUserPlan}
                        >
                          {listPlans.map((item, index) => {
                            return (
                              <option key={index} value={item}>
                                {item}
                              </option>
                            );
                          })}
                        </Form.Select>
                      </div>
                      <div>
                        <span className="text-secondary fw-semibold dashboard-form-edit-user-title">
                          Plano
                        </span>
                        <br />
                        <p
                          className={`fw-bold dashboard-form-edit-user-sub-title text-break ${
                            statusMode ? "text-light" : ""
                          }`}
                        >
                          {dataUserToShow["plano"]}
                        </p>
                      </div>
                      <div>
                        <span className="text-secondary fw-semibold dashboard-form-edit-user-title">
                          Cuponuser
                        </span>
                        <br />
                        <p
                          className={`fw-bold dashboard-form-edit-user-sub-title text-break ${
                            statusMode ? "text-light" : ""
                          }`}
                        >
                          {dataUserToShow["cuponuser"] === null
                            ? "_"
                            : dataUserToShow["cuponuser"]}
                        </p>
                      </div>
                      <div>
                        <span className="text-secondary fw-semibold dashboard-form-edit-user-title">
                          Data expiracao
                        </span>
                        <br />
                        <div id="dashboard-form-edit-user-calendar">
                          <Calendar
                            value={valueCalendar}
                            onChange={ChangeValueCalendar}
                            dateFormat="dd/mm/yy"
                            className="border rounded"
                            showIcon
                          />
                        </div>
                      </div>

                      <div
                        id="dashboard-form-edit-user-btn-controls"
                        className="d-flex align-items-end justify-content-end"
                      >
                        <button
                          disabled={canUpdateUser}
                          className="btn btn-success fw-bold dashboard-edit-user-btn-update"
                          onClick={startUpdateUser}
                        >
                          Atualizar
                        </button>
                        <div className="mx-2"></div>
                        <button
                          className="btn btn-danger fw-bold dashboard-edit-user-btn-delete"
                          onClick={startDelete}
                        >
                          Deletar
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : pageSession === "loading" ? (
        <LoadingPage />
      ) : (
        <MessageError />
      )}
    </>
  );
}
